// :: Checklist Images Store
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

// :: State
const state = {
  itemsActualState: {},
  itemsCheck: {}
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
